import { useCommonWidgetHandlers } from './use-common-widget-handlers';
import TextWidget from '../../../editor/features/build/requestModels/widgets/TextWidget';

export const useTextWidgetHandlers = () => {
  const commonWidgetHandlers = useCommonWidgetHandlers();

  const addNew = async (
    dialogueId: number,
    sortOrder: number,
    isSmsRelated?: boolean,
  ) => {
    const newWidget = TextWidget.make(dialogueId, '', sortOrder, isSmsRelated);
    return commonWidgetHandlers.create(newWidget, dialogueId, sortOrder);
  };

  return {
    delete: commonWidgetHandlers.delete,
    updateText: commonWidgetHandlers.updateBodyText,
    addNew,
  };
};
